let API_URL = "";
let UPLOAD_DOCS_URL = "";
let famDoc = "";
const isProd = false;

if (isProd) {
  API_URL = "https://api.rivp.fr/index.php?route=api/";
  UPLOAD_DOCS_URL =
    "rivpdocs/uploaddocsApie&famdoc=PORTAILCOLLABORATEUR&typedoc=JUSTIFICATIF&numdossier=";
  famDoc = "PORTAILCOLLABORATEUR";
} else {
  API_URL = "https://r-project.rivp.fr/rivp-api/index.php?route=api/";
  UPLOAD_DOCS_URL =
    "rivpdocs/uploaddocsApie&famdoc=PORTAILCOLLABORATEURDEV&typedoc=JUSTIFICATIF&numdossier=";
  famDoc = "PORTAILCOLLABORATEURDEV";
}

const login = (token) => {
  return fetch(API_URL + "portailCollaborateur/login", {
    method: "POST",
    body: JSON.stringify({
      token: token,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getForms = (token) => {
  return fetch(API_URL + "portailCollaborateur/getForms", {
    method: "POST",
    body: JSON.stringify({
      token: token,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getDocs = (numDossier) => {
  return fetch(
    API_URL +
      "rivpdocs/getdocsApie&dossier_id=" +
      numDossier +
      "&propr=" +
      famDoc,
    {
      method: "GET",
    }
  );
};

const getDocsByDemandeId = (demandeId) => {
  return fetch(
    API_URL +
      "rivpdocs/getdocsByDemandeIdApie&demandeId=" +
      demandeId +
      "&propr=" +
      famDoc,
    {
      method: "GET",
    }
  );
};

const getFilters = (token) => {
  return fetch(API_URL + "portailCollaborateur/getFilters", {
    method: "POST",
    body: JSON.stringify({
      token: token,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const submitDemande = (formData) => {
  return fetch(API_URL + "portailCollaborateur/submitDemande", {
    method: "POST",
    body: formData,
  });
};

const updateRepriseDemande = (formData) => {
  return fetch(API_URL + "portailCollaborateur/updateRepriseDemande", {
    method: "POST",
    body: formData,
  });
};

const uploadDocs = (numDossier, formDataFile) => {
  return fetch(API_URL + UPLOAD_DOCS_URL + numDossier, {
    method: "POST",
    headers: {
      Accept: "*/*",
    },
    body: formDataFile,
  });
};

const getDemande = (token, demandeId) => {
  return fetch(API_URL + "portailCollaborateur/getDemande", {
    method: "POST",
    body: JSON.stringify({
      token: token,
      demandeId: demandeId,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getDemandes = async (token, limit = null) => {
  return fetch(API_URL + "portailCollaborateur/getDemandes", {
    method: "POST",
    body: JSON.stringify({
      token: token,
      limit: limit,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getPostalCodeRelatedData = (postalCode) => {
  return fetch(
    API_URL +
      "portailCollaborateur/getPostalCodeRelatedData&postalCode=" +
      postalCode,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

const getDemandesWithPerimeter = (token) => {
  return fetch(API_URL + "portailCollaborateur/getDemandesWithPerimeter", {
    method: "POST",
    body: JSON.stringify({
      token: token,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const updateDemande = (formData) => {
  return fetch(API_URL + "portailCollaborateur/updateDemande", {
    method: "POST",
    body: formData,
  });
};

const exportDemandes = (exportOptions) => {
  return fetch(API_URL + "portailCollaborateur/exportDemandes", {
    method: "POST",
    body: JSON.stringify(exportOptions),
  });
};

const downloadCount = (idAllianz) => {
  return fetch(API_URL + "portailCollaborateur/downloadCount", {
    method: "POST",
    body: JSON.stringify({
      idAllianz: idAllianz,
    }),
  });
};

const ApiService = {
  login,
  getForms,
  getDocs,
  getFilters,
  submitDemande,
  uploadDocs,
  getDemandes,
  getPostalCodeRelatedData,
  getDemandesWithPerimeter,
  getDemande,
  updateDemande,
  exportDemandes,
  downloadCount,
  getDocsByDemandeId,
  updateRepriseDemande
};

export default ApiService;
